module.exports = __webpack_public_path__ + "static/headsets-3d7cf5bc79de9941b67de73d9281d5d2.jpg";